import { FeatureFlagKey } from '@applyboard/ab-rpj';

export const localConfig = {
  simple_flag: {
    enabled: true,
  },
  simple_disabled_flag: {
    enabled: false,
  },
  simple_variation: {
    enabled: true,
    variation: 'other_variation',
  },
  content_program_search_success_score: {
    enabled: true,
    meta_data: {
      OVERRIDDEN_USER_IDS: '1,2',
    },
    variation: 'active',
  },
  vas_rbc_gic_extended_countries: {
    enabled: false,
  },
  vas_loan_followup_form: {
    enabled: true,
  },
  [FeatureFlagKey.UseAbidCustomizationLogin]: {
    enabled: false,
  },
  dsj_onboarding_revamp: {
    enabled: false,
    variation: 'landing_page_version',
  },
  vas_nepal_shoppify_store: {
    enabled: false,
  },
};
